import React, { useState, useRef, useEffect, useCallback } from 'react';
import isEqual from 'lodash/isEqual';
import {filter, isEmpty, isUndefined} from 'lodash';

//工具类
const getServiceLangCode = (i18n) => {
  return (i18n?.language==='zh-CN'?'zh':i18n?.language)??'zh';
};
const getProductImg = (prod) => {
  return prod.mime === null ? null : filter(prod.mime, { mimePurpose: 'thumbnail' })?.[0]?.['mimeSource']?.[0]?.['#text'];
};
const getValueByLanguage = (i18n, value) => {
  if (!i18n) {
    return (typeof value === 'string' ? value : value['zh']);
  }
  const local = getServiceLangCode(i18n);
  if (isUndefined(value))
    return value;
  return (typeof value === 'string' ? value : value[local]);
};
const openSFUrl = (url) => {
  //window.parent?.location.href = url;
  window?.open(url, '_blank');
};
const openSFUrlCurrentWindow = (url) => {
  window.location.href = url;
};
const queryParse = (query) => {
  query = query.substring(query.indexOf('?') + 1);
  const array = query.split('&');
  const params = {};
  array.forEach(item => {
    const key = item.substring(0, item.indexOf('='));
    if(key.length===0)
      return;
    const value = decodeURIComponent(item.substring(item.indexOf('=') + 1));
    params[key] = value;
  });
  return params;
};
const appendUrlParameter =(url, key, value) => {
  const querys = queryParse(url);
  console.log("querys=====",querys)
  const hasQuery = !isEmpty(querys);
  const separator = hasQuery? '&' : '?';
  const newQuery = `${key}=${encodeURIComponent(value)}`;
  return `${url}${separator}${newQuery}`;
};
const Utills = {getServiceLangCode,
  getValueByLanguage,
  getProductImg,
  openSFUrl,
  appendUrlParameter,
  openSFUrlCurrentWindow
};
export default Utills;
